export default "__VITE_ASSET__hxmWs4TZ__"